import TRANSLATIONS_MODE from './constants';
import TranslationsTable from './TranslationsTable';

const AdminPanelTranslations = () => (
  <TranslationsTable catalog={TRANSLATIONS_MODE.admin} />
);

export default AdminPanelTranslations;
